<template>
  <div>
    <v-row class="mx-6">
    </v-row>
    <v-row class="mx-6">
      <v-col cols="4">
        <v-text-field
          v-model="loginId"
          label="ログインID"
          :counter="16"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col cols="4">
        <v-text-field
          v-model="password"
          :label="passwordLabel"
          :counter="10"
        ></v-text-field>
        <v-btn small color="secondary" @click="generatePassword()">パスワード自動生成</v-btn>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col>
        <p class="mb-1">利用可能科目設定</p>
        <v-subject-table :hideSubjectCodes="['sh']"/>
        <p class="mt-5 mb-1">社会の分野設定</p>
        <v-subject-option-table />
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col>
        <p class="mb-1 form-label">アカウント体系</p>
        <v-radio-group
          v-model="accountType"
          hide-details
          row
        >
          <v-radio
            v-for="option in accountTypeOptions"
            :key="option.value"
            :label="option.text"
            :value="option.value"
            color="secondary"
          />
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col>
        <p class="mb-4 form-label">残りダウンロード回数</p>
        <v-text-field
          style="width:200px"
          v-model="remainingDownloadCount"
          outlined
          :rules="rules"
          color="secondary"
          :disabled="accountType === 'paid'"
          dense
        />
      </v-col>
    </v-row>
    <v-btn class="mt-6 ml-6" small color="secondary" dark @click.stop="submit">保存</v-btn>
  </div>
</template>

<script>
import VSubjectTable from '@/components/molecules/SubjectTable'
import VSubjectOptionTable from '@/components/molecules/SubjectOptionTable'

export default {
  components: {
    VSubjectTable,
    VSubjectOptionTable
  },
  data () {
    return {
      accountTypeOptions: [
        { text: '印刷あり※有料', value: 'paid' },
        { text: '印刷なし※無料', value: 'free' },
      ],
      rules: [
        value => !value.match(/[^0-9]/) || '数字のみで入力してください',
        value => value <= 15 || '15以内で入力してください',
        value => value >= 0 || '0以上で入力してください',
      ],
    }
  },

  methods: {
    async submit() {
      const res = await this.$store.dispatch('account/validate')
      if (res.status === 'error') this.$toasted.global.error({ message: res.message })
      else this.$emit('submit')
    },
    generatePassword() {
      // パスワードをランダムに生成
      // 【パスワード条件：半角英数字、半角記号!#$%&?@が使用可能、8文字】
      const availableMap = "abcdefghkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789";
      let random = Array.from(Array(availableMap.length)).map((_, index) => availableMap[index])
      random = this.shuffle(random).join('')
      this.$store.commit('account/setPassword', {
        password: random.slice(0, 8)
      })
    },
    shuffle([...array]) {
      for (let i = array.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
  },

  computed: {
    passwordLabel() {
      return this.$store.getters['account/passwordLabel']
    },
    loginId: {
      get() {
        return this.$store.state.account.login
      },
      set(value) {
        this.$store.commit('account/setLogin', {
          login: value
        })
      }
    },
    password: {
      get() {
        return this.$store.state.account.password
      },
      set(value) {
        this.$store.commit('account/setPassword', {
          password: value
        })
      }
    },
    accountType: {
      get() {
        return this.$store.state.account.accountType
      },
      set(value) {
        this.$store.commit('account/setAccountType', {
          accountType: value
        })
      }
    },
    remainingDownloadCount: {
      get() {
        return this.$store.state.account.remainingDownloadCount
      },
      set(value) {
        this.$store.commit('account/setRemainingDownloadCount', {
          remainingDownloadCount: value
        })
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.form-label
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;

</style>
